import { useState } from 'react';

const FleetSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const vehicles = [
    {
      name: 'Microbus 8 Plazas',
      capacity: '8 pasajeros',
      features: ['Asientos cómodos', 'Aire acondicionado', 'Amplio espacio', 'Ventanas amplias'],
      description: 'Perfecto para grupos pequeños'
    },
    {
      name: 'Microbus 12 Plazas',
      capacity: '12 pasajeros',
      features: ['Configuración 2+1', 'Ventanas panorámicas', 'Climatización', 'Espacio para equipaje'],
      description: 'Ideal para traslados y grupos medianos'
    },
    {
      name: 'Microbus 16 Plazas',
      capacity: '16 pasajeros',
      features: ['Asientos reclinables', 'Espacio para equipaje', 'Iluminación LED', 'Ventilación individual'],
      description: 'Excelente para eventos y excursiones grupales'
    },
    {
      name: 'Microbus 19 Plazas',
      capacity: '19 pasajeros',
      features: ['Máxima capacidad', 'Doble puerta acceso', 'Compartimento equipaje', 'Suspensión confort'],
      description: 'Nuestra opción más espaciosa para grupos grandes'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % vehicles.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + vehicles.length) % vehicles.length);
  };

  return (
    <section id="flota" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-lg tracking-wide">NUESTRA FLOTA</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Microbuses para Grupos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Flota especializada en microbuses de 8 a 19 plazas.
            Vehículos cómodos y seguros para tu grupo.
          </p>
        </div>

        {/* Vehicle Carousel */}
        <div className="relative max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {/* Icon placeholder instead of image */}
              <div className="relative h-96 lg:h-auto bg-gradient-to-br from-teal-50 to-teal-100 flex flex-col items-center justify-center">
                <div className="w-32 h-32 bg-teal-600/10 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-bus-2-line text-teal-600" style={{ fontSize: '4rem' }}></i>
                </div>
                <span className="text-teal-700 font-semibold text-xl">{vehicles[currentSlide].name}</span>
                <span className="text-teal-500 mt-2">{vehicles[currentSlide].capacity}</span>
              </div>

              {/* Content */}
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  {vehicles[currentSlide].name}
                </h3>
                
                <p className="text-gray-600 mb-6 text-lg leading-relaxed">
                  {vehicles[currentSlide].description}
                </p>

                {/* Capacity */}
                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-user-line text-teal-600 text-xl"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Capacidad</div>
                      <div className="text-gray-600">{vehicles[currentSlide].capacity}</div>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-luggage-cart-line text-teal-600 text-xl"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">Equipaje</div>
                      <div className="text-gray-600">Amplio maletero</div>
                    </div>
                  </div>
                </div>

                {/* Features */}
                <div className="mb-8">
                  <h4 className="font-semibold text-gray-900 mb-4">Características:</h4>
                  <div className="grid grid-cols-2 gap-3">
                    {vehicles[currentSlide].features.map((feature, index) => (
                      <div key={index} className="flex items-center">
                        <div className="w-5 h-5 bg-teal-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                          <i className="ri-check-line text-teal-600 text-xs"></i>
                        </div>
                        <span className="text-gray-700 text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* CTA Button */}
                <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-line mr-2"></i>
                  Reservar Este Vehículo
                </button>
              </div>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button 
            onClick={prevSlide}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-gray-600 text-xl"></i>
          </button>
          
          <button 
            onClick={nextSlide}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line text-gray-600 text-xl"></i>
          </button>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center mt-8 space-x-2">
          {vehicles.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentSlide 
                  ? 'bg-teal-600 w-8' 
                  : 'bg-gray-300 hover:bg-gray-400'
              }`}
            />
          ))}
        </div>

        {/* Fleet Stats */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-gradient-to-r from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-car-line text-white text-2xl"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-2">25+</div>
            <div className="text-gray-600">Vehículos</div>
          </div>

          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-gradient-to-r from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-2">100%</div>
            <div className="text-gray-600">Seguro Completo</div>
          </div>

          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-gradient-to-r from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-tools-line text-white text-2xl"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-2">30</div>
            <div className="text-gray-600">Días Mantenimiento</div>
          </div>

          <div className="text-center p-6 bg-white rounded-xl shadow-lg">
            <div className="w-16 h-16 bg-gradient-to-r from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-leaf-line text-white text-2xl"></i>
            </div>
            <div className="text-3xl font-bold text-gray-900 mb-2">Euro 6</div>
            <div className="text-gray-600">Estándar Ecológico</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FleetSection;
